const tables = {
  'agile-product-development/products': (
    <table className="mobile-fix">
      <tr>
        <td>
          <strong>Good Product</strong>
        </td>
        <td>
          <strong>Great Product</strong>
        </td>
        <td>
          <strong>Why?</strong>
        </td>
      </tr>
      <tr>
        <td>WebEx, Goto meeting, Google Hangouts</td>
        <td>Zoom</td>
        <td>
          Zoom works consistently well across platforms and low latency environments. Others failed miserably at this,
          even with major market share. (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.forbes.com/sites/alexkonrad/2019/04/19/zoom-zoom-zoom-the-exclusive-inside-story-of-the-new-billionaire-behind-techs-hottest-ipo/"
          >
            Great story of how Zoom got started
          </a>
          )
        </td>
      </tr>
      <tr>
        <td>Messenger, Kik, etc.</td>
        <td>WhatsApp</td>
        <td>
          WhatsApp built on every major platform to make sure users could talk in low-income areas like Africa and
          India. Other platforms built for iOS only, etc. It worked for Instagram, but a much different strategy for
          WhatsApp.
        </td>
      </tr>
      <tr>
        <td>Hipchat, Microsoft Lync / Skype for Business</td>
        <td>Slack</td>
        <td>
          Slack solves one important problem: communication.
          <p>
            They have a fantastic on-boarding experience that they continue to improve, and virality was built into the
            product from day one (adding other team members).
          </p>
          <p>They have an intuitive user experience that delights users. The others feel clunky and frustrating.</p>
        </td>
      </tr>
    </table>
  ),
  'agile-product-development/companies': (
    <table className="mobile-fix">
      <tr>
        <td>
          <strong>Company</strong>
        </td>
        <td>
          <strong>Disrupt</strong>
        </td>
        <td>
          <strong>Iterative Steps</strong>
        </td>
      </tr>
      <tr>
        <td>Uber</td>
        <td>Transportation</td>
        <td>
          Started by serving business people who took Towncars. It wasn’t until years later that they launched UberX.
        </td>
      </tr>
      <tr>
        <td>Instagram</td>
        <td>Social Media</td>
        <td>
          Started with iOS only, completely excluding Android users. Only launched Android after announcing FB
          acquisition.
        </td>
      </tr>
      <tr>
        <td>Airbnb</td>
        <td>Hotels</td>
        <td>
          Started with private rooms only. It was years until they started attracting the vacation rental market for
          those who wanted private apartments and houses.
        </td>
      </tr>
      <tr>
        <td>WhatsApp</td>
        <td>Communication</td>
        <td>
          WhatsApp was initially status updates and your contacts got alerted by push notification every time your
          status changed. You actually couldn’t send a message until v2 of the product.
          <p>
            Part of {`WhatsApp's`} success is that they built a text-messaging platform for the world with a very small
            number of servers powering all of it. How? They wrote WhatsApp with Erlang, which is extremely scalable,
            efficient, fault-tolerant, and is the same underlying technology as Elixir (Plug, Elixir is Foxbox Digital’s
            backend language of choice).
          </p>
        </td>
      </tr>
    </table>
  ),
};

const TableHardcoded = ({ id }) => {
  return tables[id] || null;
};

export default TableHardcoded;
